import { useState } from 'react'
import { Option } from '../../../context/SeaWater/types'
import { NetWashingDetail } from '../../../types'

export interface Values {
  [key: string]: NetWashingDetail
}

interface Args {
  initialValues?: NetWashingDetail[]
}

export const useValuesCategoryTwo = ({ initialValues }: Args) => {
  const [values, setValues] = useState<Values>(() => {
    if (!initialValues) return {}

    return Object.fromEntries(initialValues.map((value) => [value.washingTypeId, { ...value }]))
  })

  const handleSetValue = (values: {
    value: number
    item: Option
    name: keyof NetWashingDetail
  }) => {
    setValues((oldValues) => {
      const { item, name, value } = values
      return {
        ...oldValues,
        [item.id]: {
          ...oldValues[item.id],
          washingTypeId: item.id,
          [name]: value,
          washingTypeName: item.name,
        },
      }
    })
  }

  const deleteById = (id: number) => {
    const { [id]: toDelete, ...rest } = values
    setValues({ ...rest })
  }

  return { values, handleSetValue, deleteById }
}
